export default {
  header: 'Definície parametrov zariadenia',
  subheader: 'Táto stránka umožňuje spravovať vlastné parametre zariadenia, ktoré môžu byť opätovne použité v nástroji na tvorbu signálov.',
  empty: 'Nie sú definované žiadne vlastné parametre zariadenia.',
  confirmDelete: {
    header: 'Odstrániť parameter "{parameter}"?',
    message: 'Túto definíciu môže používať viacero zariadení. Túto akciu nie je možné vrátiť späť.',
  },
};
